module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames5-4d0aaacef535120137b71f0263ecdc9c.png";